module.exports = __webpack_public_path__ + "static/media/card-odontologia.eff0e981.svg";